import React, { useEffect, useState } from 'react';
import { PageContainer } from '../../common/components/PageContainer/PageContainer';
import { GlassContainer } from '../../common/components/GlassContainer/GlassContainer';
import { UploadProgressBar } from '../../common/components/UploadProgressBar/UploadProgressBar';
import {
  ContentWrapper,
  UploadNotificationWrapper,
  FadeOutWrapper,
} from './VideoUploadingPage.styles';
// import { UploadIcon } from '../../common/assets/UploadIcon';
// import { UploadProgressStrings } from '../../common/localization/en';
import { useTypedSelector } from '../../store/store';
import { UploadErrorNotification } from '../../common/components/UploadErrorNotification/UploadErrorNotification';
// import { useThemeLayout } from '../../common/hooks/useThemeLayout';
import { IncentiveBlock } from '../../common/components/IncentiveBlock/IncentiveBlock';
import { PortalWrapper } from '../../common/components/PortalWrapper/PortalWrapper';

const AVERAGE_UPLOAD_SPEED = 0.6; // Mb per second;

interface Props {
  onRestartClick: () => void;
}

export const VideoUploadingPage: React.FC<Props> = ({ onRestartClick }) => {
  // const { isDarkTheme } = useThemeLayout();

  const { uploadingIterations, isUploadError, isUploadInprogress, uploadingProgress, isUploadComplete } =
    useTypedSelector((state) => state.upload);
  // const { items: quesstions } = useTypedSelector((state) => state.ui.questions);
  // const hasAnsweredQuestions = quesstions.length > 1;

  const [isEstimationTimeCalculated, setIsEstimationTimeCalculated] = useState(false);
  const [, setEstimationTime] = useState(0);
  const [hideTopBanner, setHideTopBanner] = useState(false);
  const [dontshowTopBanner, setDontshowTopBanner] = useState(false);

  useEffect(() => {
    if (uploadingIterations.length > 0 && !isEstimationTimeCalculated) {
      const totalSize = uploadingIterations[0].total / 1024 / 1024;

      setEstimationTime(totalSize / AVERAGE_UPLOAD_SPEED);
      setIsEstimationTimeCalculated(true);
    }
  }, [isEstimationTimeCalculated, uploadingIterations]);

  // const minutes = Math.floor(estimationTime / 60);
  // const seconds = Math.ceil(estimationTime % 60);
  const showCompleteScreen = !isUploadInprogress && uploadingProgress === 100;

  useEffect(() => {
    if (isUploadComplete) {
      setDontshowTopBanner(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (showCompleteScreen) {
      const timeout = setTimeout(() => {
        setHideTopBanner(true);
      }, 5000);
      return () => {
        clearTimeout(timeout);
      };
    }
  }, [showCompleteScreen]);
  return (
    <PageContainer withOffsetTop={false}>
      <GlassContainer my="-30px" hideGlass={true}>
        <ContentWrapper>
          {dontshowTopBanner ? (
            <></>
          ) : (
            <PortalWrapper percent={100} offset={-96}>
              <FadeOutWrapper $fadeOut={hideTopBanner && !isUploadError}>
                <UploadProgressBar />
              </FadeOutWrapper>
            </PortalWrapper>
          )}
          {isUploadError ? (
            <UploadNotificationWrapper>
              <UploadErrorNotification onRestartClick={onRestartClick} />
            </UploadNotificationWrapper>
          ) : (
            <>
              <IncentiveBlock showQuestions={true} isCompleteScreen={true} showTopBanner={true} />
            </>
          )}
        </ContentWrapper>
      </GlassContainer>
    </PageContainer>
  );
};
